import React from 'react';
// import ProjektDaten, { GetProjektDatenFormStruc } from './content/ProjektDaten';
import Antragsteller, { GetAntragstellerFormStruc } from './content/Antragsteller';
import Projektbeschreibung, { GetProjektBeschreibungFormStruc } from './content/Projektbeschreibung';
import Erklaerung, { GetErklaerungFormStruc } from './content/Erklaerung';
import Abschluss, { GetAbschlussFormStruc } from './content/Abschluss';
import Zeitplanung, { GetZeitplannungFormStruc } from './content/Zeitplanung';
import { assignIdsToStruc, enumT, groupKostenByPosition, isTrue } from '../../../../../utils/helper';
import { get } from 'lodash';

import Schema from '../../../../../lib/paths/zuwendungsantrag_FULL_Paths.json';
import Partner, { GetPartnerFormStruc } from './content/Partner';
import { Typography } from '@mui/material';
import Anlagen, { GetAnlagenFormStruc } from './content/Anlagen';
import ZuwendungsBescheid from './content/ZuwendungsBescheid';
import AblehnungsBescheid from './content/AblehnungsBescheid';
import { GetKosten } from './content/kosten/GetKosten';
const P = Schema.attributes;

export const ZuwendungsantragStructure = (application: any, kostenKategories: any, readOnly: boolean) => {
	const kostenkategoriesGroup = groupKostenByPosition(kostenKategories);

	let STRUC: any[] = [
		{
			label: 'Antragsteller/in',
			content: <Antragsteller />,
			formStruc: GetAntragstellerFormStruc(application),
			showError: false,
		},
		{
			label: 'Projektdaten',
			content: <Projektbeschreibung />,
			formStruc: GetProjektBeschreibungFormStruc(application, readOnly),
		},
		...(isTrue(get(application, P.Allgemein_Kooperationsprojekt.path))
			? [{ label: 'Partner', content: <Partner />, formStruc: GetPartnerFormStruc(application, readOnly) }]
			: []),
	];

	for (const kostenposition in kostenkategoriesGroup) {
		const kostenarts = kostenkategoriesGroup[kostenposition];
		kostenarts.forEach((kostenart: string) => {
			STRUC.push({
				label: enumT(kostenart),
				content: <Typography variant="h3">{enumT(kostenart)}</Typography>,
				children: GetKosten(application, kostenposition, kostenart, kostenKategories),
			});
		});
	}

	STRUC.push({
		label: 'Zeitplanung',
		content: <Zeitplanung />,
		formStruc: GetZeitplannungFormStruc(application),
		showError: false,
	});
	STRUC.push({
		label: 'Anlagen',
		content: <Anlagen />,
		formStruc: GetAnlagenFormStruc(),
	});
	STRUC.push({
		label: 'Erklärungen',
		content: <Erklaerung />,
		formStruc: GetErklaerungFormStruc(),
	});
	STRUC.push({
		label: 'Antragsübersicht',
		content: <Abschluss />,
		formStruc: GetAbschlussFormStruc(application),
	});

	if (get(application, `${P.Bescheid_Bescheid.path}.id`)) {
		STRUC.push({
			label: 'Bescheid',
			content: <ZuwendungsBescheid />,
		});
	}

	if (
		get(application, `${P.Bescheid_Bescheid.path}.id`) &&
		get(application, P.Antragsstatus_Antragsstatus.path) === 'abgelehnt'
	) {
		STRUC.push({
			label: 'Bescheid',
			content: <AblehnungsBescheid />,
		});
	}

	return assignIdsToStruc(STRUC);
};
